const getRecordType = (workflow) => {
    if (!workflow) return ''
    const firstStageWithSource = workflow.stages.find((stage) => stage.source)
    if (!firstStageWithSource) return ''
    return firstStageWithSource.source
}

export { getRecordType }
